export default {"src":"/_next/static/media/doctor-icon.06655a77.svg","height":48,"width":41};